import { Component } from '@angular/core';
import { SelectionMode } from 'source/app/objects/enums/selection-mode';

@Component({
  templateUrl: './combo-box.html'  
})
export class ComboBoxComponent { 

    constructor() {
      this.ItemsSource = 
      [
        { Name:'Apple' },
        { Name:'Banana' },
        { Name:'Cherry' },
        { Name:'Orange' },
        { Name:'Pineapple' },        
        { Name:'Strawberry' },
        { Name:'Tomato' },         
      ];

      this.BiggerItemsSource =
        [
          { Name: 'Apple' },
          { Name: 'Banana' },
          { Name: 'Cherry' },
          { Name: 'Orange' },
          { Name: 'Pineapple' },
          { Name: 'Strawberry' },
          { Name: 'Tomato' },
          { Name: 'Watermelon' },
          { Name: 'Yam' },
          { Name: 'Zucchini' },
          { Name: 'Juicier Orange' },
          { Name: 'Juicier Pineapple' },
          { Name: 'Juicier Strawberry' },
          { Name: 'Juicier Tomato' },
          { Name: 'Juicier Watermelon' },
          { Name: 'Juicier Yam' },
          { Name: 'Juicier Zucchini' },
        ];      
    }

  public ItemsSource;
  public BiggerItemsSource;
  public SelectedItem;
  public MultipleMode: SelectionMode.Multiple;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/combo-box/combo-box-component.ts